module.exports = "pegasus_template/assets/themecapture1/tickets/103.png";